import { PixelPlaceholderLoader } from "@similarweb/ui-components";
import { FlexColumn } from "pro-features/styled components/StyledFlex/src/StyledFlex";
import styled from "styled-components";

const Container = styled(FlexColumn)`
    justify-content: space-between;
    padding: 6px 0px;
`;

export const Loader = () => {
    return (
        <>
            <Container>
                <PixelPlaceholderLoader
                    width={44}
                    height={3}
                />
                <PixelPlaceholderLoader
                    width={44}
                    height={3}
                />
            </Container>
            <Container>
                <PixelPlaceholderLoader
                    width={84}
                    height={3}
                />
                <PixelPlaceholderLoader
                    width={84}
                    height={3}
                />
            </Container>
        </>
    );
};
